import React from 'react';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import BreederProfileLocationLinksGroup from './BreederProfileLocationLinksGroup';
import { popularStatesResourceDefinition } from './utils/queryDefinitions';

interface BreederProfilePopularStatesProps {
  breedName: string;
  breedId: string | number;
}

export default function BreederProfilePopularStates({
  breedName,
  breedId
}: BreederProfilePopularStatesProps) {
  const { value: statesData, isFetching } = useResourceQuery(
    popularStatesResourceDefinition(breedId)
  );

  return (
    <BreederProfileLocationLinksGroup
      breedName={breedName}
      linksData={statesData}
      header={`Find ${breedName} puppies by state`}
      linkType="state"
      limit={50}
      wideLayout
      isFetching={isFetching}
    />
  );
}
